class Controller {
  constructor(Events, City) {
    "ngInject";

    this.Events = Events;
    this.City = City;
    this.errorNotificationEvent = this.Events.eventsType.onShowErrorNotification;
    this.successNotificationEvent = this.Events.eventsType.onShowSuccessNotification;
    this.isDisabled = true;

    this.updateVerification = this.updateVerification.bind(this);
  }

  $onInit() {
    this.City.getCaptainVerification(this.cityId)
      .$promise.then((response) => {
        this.captainVerificationConfiguration = response;
      })
      .catch((err) => this.Events.emit(this.errorNotificationEvent, err.data));
  }

  updateVerification() {
    this.City.putAction(
      this.cityId,
      "verification_headers",
      this.captainVerificationConfiguration
    )
      .$promise.then((response) => {
        this.captainVerificationConfiguration = response;
        this.Events.emit(this.successNotificationEvent, {
          message: "Captain Verification Configuration is updated successfully",
        });
      })
      .catch((err) => {
        this.Events.emit(this.errorNotificationEvent, err.data);
        this.isDisabled = false;
      });
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/cityCaptainVerification/cityCaptainVerification.controller.js